<template>
  <div v-show="!loading">
    <div class="col-12 d-flex justify-content-center align-items-center flex-column">
      <span class="btn-subtle-success"
        >Pack {{ invoice.plan.price }}
        {{ invoice.plan.name }}
      </span>
      <h4 class="text-secondary">{{ invoice.currency.name }} Payment</h4>
      <h6 class="text-secondary">(QR CODE)</h6>
      <qrcode
        :class="!invoice.price && 'opacity-wallet'"
        :value="`${invoice.wallet}`"
        :options="{ width: 233 }"
      ></qrcode>

      <span class="alert alert-success mt-5">
        <h5>
          Awaiting Payment
          <span :id="`ten-countdown`" class="ml-5"></span>
        </h5>
      </span>

      <button
        class="btn btn-secondary mt-5 mb-5 btn-block text-dark"
        v-if="activationWallet > 0"
        @click="() => $emit('activation-wallet')"
        :disabled="loading"
      >
        <template v-if="loading">
          Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
          Click Here to Use {{ activationWallet }} from Activation Wallet to Pay
          <i class="mdi mdi-gesture-double-tap"></i
        ></template>
      </button>
    </div>
    <div class="col-12 text-black mt-5">
      <fieldset>
        <div class="form-group">
          <label for="">
            <h5 class="text-white">Amount Due</h5>
          </label>
          <div class="input-group">
            <span class="input-group-btn">
              <button type="submit" class="btn btn-default">
                <cryptoicon :symbol="_getCurrencySymbol(invoice)" size="20" />
              </button>
            </span>
            <input
              type="text"
              name="message"
              placeholder="Type Message ..."
              class="form-control"
              :value="invoice.price"
              v-clipboard:copy="invoice.price"
              v-clipboard:success="onCopy"
            />
            <span class="input-group-btn">
              <button
                type="submit"
                class="btn btn-default"
                v-clipboard:copy="invoice.price"
                v-clipboard:success="onCopy"
              >
                <i class="text-success fa fa-clone"></i>
              </button>
            </span>
          </div>
        </div>
        <div class="form-group">
          <label for="">
            <h5 class="text-white">Address</h5>
          </label>
          <div class="input-group">
            <span class="input-group-btn">
              <button type="submit" class="btn btn-default">
                <cryptoicon :symbol="_getCurrencySymbol(invoice)" size="20" />
              </button>
            </span>
            <input
              type="text"
              name="message"
              placeholder="Type Message ..."
              class="form-control"
              :value="invoice.wallet"
              v-clipboard:copy="invoice.wallet"
              v-clipboard:success="onCopy"
            />
            <span class="input-group-btn">
              <button
                type="submit"
                class="btn btn-default"
                v-clipboard:copy="invoice.wallet"
                v-clipboard:success="onCopy"
              >
                <i class="text-success fa fa-clone"></i>
              </button>
            </span>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "payment-info",
  props: {
    invoice: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      counter: null,
    };
  },
  computed: {
    ...mapGetters("invoice", {
      loading: "isLoading",
    }),
    activationWallet() {
      return this.$store.getters.currentUser.vault.comissions_amount;
    },
  },
  methods: {
    _getCurrencySymbol(invoice) {
      let result = invoice.currency.name;

      if (result.includes("USDT")) {
        result = "usdt";
      }

      return result;
    },
    onCopy() {
      this.$toasted.show("Copied to Clippboard!", {
        position: "top-right",
        duration: 5000,
        type: "success",
        closeOnSwipe: true,
      });
    },
    setTimer(elementName, minutes, seconds) {
      let state = this;
      let element, endTime, hours, mins, msLeft, time;

      function twoDigits(n) {
        return n <= 9 ? "0" + n : n;
      }

      function updateTimer() {
        msLeft = endTime - +new Date();
        if (msLeft < 1000) {
          element.innerHTML = "Time is up!";
        } else {
          time = new Date(msLeft);
          hours = time.getUTCHours();
          mins = time.getUTCMinutes();
          element.innerHTML =
            (hours ? hours + ":" + twoDigits(mins) : mins) +
            ":" +
            twoDigits(time.getUTCSeconds());
          state.counter = setTimeout(updateTimer, time.getUTCMilliseconds() + 500);
        }
      }
      element = document.getElementById(elementName);

      endTime = +new Date() + 1000 * (60 * minutes + seconds) + 500;
      updateTimer();
    },
    reset() {
      clearTimeout(this.counter);
    },
  },
};
</script>
